/**
 * Children of the sidebar's Compliance section: the five areas the Compliance
 * Overview scores, then the other compliance pages under a "Tools" sub-heading
 * (shown only when both groups have something the user can open).
 *
 * @param {{ name: string, href: string, icon?: any, badge?: string, tool?: boolean }[]} visibleLinks
 *   the links this user may open, in display order
 * @returns {object[]} sidebar children; the heading is { isHeading: true, name: 'Tools' }
 */
export function complianceNavChildren(visibleLinks) {
  return visibleLinks.flatMap(({ name, href, icon, badge, tool }, index) => {
    const child = badge ? { name, href, icon, badge } : { name, href, icon };
    const firstTool = tool && index > 0 && !visibleLinks[index - 1].tool;
    return firstTool ? [{ isHeading: true, name: 'Tools', href: 'compliance-tools-heading' }, child] : [child];
  });
}
